module.exports = __webpack_public_path__ + "static/img/home_culture_02.24b6814.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/home_culture_02.png
// module id = 9EZE
// module chunks = 0